import { DateRangeDropdownV2, FormField } from '@/components/custom/erp';
import { DETAIL_BY_OPTIONS, GROUP_BY_OPTIONS } from '../../constant';
import { Label } from '@/components/ui/label';

const BasicInfo = () => {
  return (
    <div className='space-y-2 p-4'>
      {/* Date Range Fields */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Ngày nhập từ/đến</Label>
        <DateRangeDropdownV2
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          toFieldClassName='w-40'
          fromFieldClassName='w-40'
        />
      </div>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Báo cáo theo</Label>
        <div className='w-44'>
          <FormField name='detail_by' type='select' options={DETAIL_BY_OPTIONS} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Nhóm theo</Label>
        <div className='w-44'>
          <FormField name='group_by' type='select' options={GROUP_BY_OPTIONS} className='w-full' />
        </div>
        <div className='ml-24'>
          <FormField
            name='loai_hang_yn'
            type='checkbox'
            label='Hàng hoá và dịch vụ'
            labelClassName='w-40 min-w-40 text-left'
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
